
class CodeMirrorHelper {
  static wrapSelection(cm, wrapChar, wrapCharAfter, adjustPosition = 0) {
    let doc = cm.getDoc()
    let selection = doc.getSelection()
    let cursor = doc.getCursor()
    if (!wrapCharAfter) {
      wrapCharAfter = wrapChar
    }

    doc.replaceSelection(`${wrapChar}${selection}${wrapCharAfter}`)

    let endCharPos = cursor.ch + wrapChar.length
    let startCharPos = endCharPos - selection.length
    if (adjustPosition > 0) {
      doc.setSelection({ line: cursor.line, ch: endCharPos + adjustPosition })
    } else if (adjustPosition < 0) {
      doc.setSelection({ line: cursor.line, ch: startCharPos + adjustPosition })
    } else {
      doc.setSelection({ line: cursor.line, ch: endCharPos }, { line: cursor.line, ch: startCharPos })
    }

    cm.refresh()
    cm.focus()
  }

  static coverLine(cm, coverText) {
    let doc = cm.getDoc()
    let cursor = doc.getCursor()
    let pos = {
      line: cursor.line,
      ch: 0
    }
    doc.replaceRange(`${coverText} `, pos, pos)
  }

  static insertText(cm, text) {
    cm.replaceRange(text, cm.getCursor())
  }
}

export default CodeMirrorHelper
